import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { orderSuccessData, fetchUserData, setUser, orderSuccessDataGuestUser } from "../../redux/actions";
import ThankYouInvoiceView from "./ThankYouInvoiceView";

const CheckOutPage = () => {
    const location  = useLocation();
    const dispatch  =  useDispatch();
    const searchParams = new URLSearchParams(location.search);
    const reference = searchParams.get('reference');
    const isSuccess = searchParams.get("success") ? searchParams.get("success") === 'true' : void 0;
    const isTransfer = searchParams.get("transfer") ? searchParams.get("transfer") === 'true' : void 0;
    const user_data = useSelector((state) => state.user_data.user_data);    
    const [paymentData, setPaymentData] = useState(null);

    const PaymentMethod = {
        GATEWAY: 'gateway',
        BANK_TRANSFER: 'bank_transfer',
        PAYMENT_ON_DELIVERY: 'payment_on_delivery',
        CORPORATE_CREDIT: 'corporate_credit',
    };

    useEffect(() => {
    
        const init = async () => {
            try {
                if(user_data?.id) {                
                    const user = await fetchUserData();
                    if(user) {
                        dispatch(setUser(user));
                        localStorage.removeItem('cartDatas');
                        localStorage.removeItem('cartIds');
                        if (reference) {
                            const body = await orderSuccessData(reference);
                            if(body) {
                                setPaymentData(body);
                            }   
                        } 
                    }    
                } else {
                    localStorage.removeItem('cartDatas');
                    localStorage.removeItem('cartIds');
                    if (reference) {
                        const body = await orderSuccessDataGuestUser(reference);
                        if(body) {
                            setPaymentData(body);
                        }   
                    } 
                }      
            } catch (e) {
                console.warn(e);
            }
        };
    
        init();
    }, [dispatch, reference, user_data]);

    return (
        <section className="hot-deals pt-20">
            <div className='container container-lg'>
                {paymentData?.payment_method === PaymentMethod.BANK_TRANSFER && (
                    <ThankYouInvoiceView paymentData={paymentData} />
                )}

                {isSuccess && !reference && (
                    <div className="flex w-full flex-col items-center gap-y-5">
                        <h3 className="text-center mt-20 p-10">Thank you!</h3>
                        <h6 className="text-center mt-20 p-10">Your purchase is successfully completed.</h6>
                        <div className="row mt-20 p-10">
                            <div className="col-md-5"></div> 
                            <div className="col-md-2">
                                <Link className="btn btn-main px-48" to='/'>
                                    Back To E-shop
                                </Link>   
                            </div> 
                            <div className="col-md-5"></div> 
                        </div>              
                    </div>
                )}
                {isTransfer && !reference && (
                    <div className="flex w-full flex-col items-center gap-y-5">
                        <h3 className="text-center mt-20 p-10">Thank you!</h3>
                        <h6 className="text-center mt-20 p-10">Your cart has been transferred to company admin for overview!</h6>
                        <div className="row mt-20 p-10">
                            <div className="col-md-5"></div> 
                            <div className="col-md-2">
                                <Link className="btn btn-main px-48" to='/'>
                                    Back To E-shop
                                </Link>   
                            </div> 
                            <div className="col-md-5"></div> 
                        </div>                        
                    </div>
                )}
                {!isSuccess && !reference && !isTransfer && (
                    <div className="flex w-full flex-col items-center gap-y-5">
                        <h3 className="text-center mt-20 p-10">Thank you!</h3>
                        <h6 className="text-center mt-20 p-10">You payment has failed but you can still pay for your order from self service area.</h6>
                        <div className="row mt-20 p-10">
                            <div className="col-md-5"></div> 
                            <div className="col-md-2">
                                <Link className="btn btn-main px-48" to='/'>
                                    Back To E-shop
                                </Link>   
                            </div> 
                            <div className="col-md-5"></div> 
                        </div>                     
                    </div>
                )}
            </div>        
        </section>
    )
}

export default CheckOutPage;
